import { ref } from "vue"
import { cloneDeep, isEqual } from "lodash-es"

export function useChangeTracker(model) {
    const original = ref()
    const hasChanges = () => !isEqual(model.value, original.value)
    const setOriginal = (model) => original.value = cloneDeep(model.value)

    return { hasChanges, setOriginal }
}
